import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-edit-groups',
  templateUrl: './add-edit-groups.component.html',
  styleUrls: ['./add-edit-groups.component.css']
})
export class AddEditGroupsComponent implements OnInit {
  groupName = "";
  groupDescription = "";
  FireBaseTopic = "";
  groupId: number;
  groupChecked = false;

  constructor(
    public dialogRef: MatDialogRef<AddEditGroupsComponent>
    , @Inject(MAT_DIALOG_DATA) public GroupData: any, public httpClient: HttpClient,
    private snotifyService: ToastrService,) {
      
    }

  ngOnInit() {
    if (this.GroupData.groupId) {
      this.groupId = this.GroupData.groupId;
      this.groupName=this.GroupData.groupName;
      this.getGroup();
    }
  }


  getGroup() {
    this.httpClient.get(`/customergroups/${this.groupId}`).subscribe((res: any) => {
      this.groupName = res.name;
      this.groupDescription = res.description;
      this.FireBaseTopic = res.fireBaseTopic;
      this.groupId = res.id;
      this.groupChecked = res.isActive;
    });
  }

  save(form) {
    if (form.invalid)
    return
    let data: any = {
      Name: this.groupName,
      Description: this.groupDescription,
      IsActive: this.groupChecked,
      FireBaseTopic: this.FireBaseTopic
    }
    if (!this.groupId) {
      this.httpClient.post('/customergroups', data).subscribe((res) => {
        this.showMessage("Groups has been added successfully", 'success');
        this.dialogRef.close('done');
      });
    } else {
      data.Id = this.groupId;
      this.httpClient.put(`/customergroups/${this.groupId}`, data).subscribe((res) => {
        data.Name= this.groupName
        this.showMessage("Groups has been edited successfully", 'success');
        this.dialogRef.close('done');
      });
    }
  }

  showMessage(message, type) {
    switch (type) {
      case 'success':
        this.snotifyService.success("", message, {
          timeOut: 2000,
          progressBar: true,
          tapToDismiss: true,
        });
        break;
      case 'error':
        this.snotifyService.error("", message, {
          timeOut: 2000,
          progressBar: true,
          tapToDismiss: true,
        });
        break;
      default:
        break;
    }

  }

  close() {
    this.dialogRef.close();
  }

  activeHandler(event) {
    this.groupChecked = event.target.checked;
  }

}
